import axios from "src/lib/axios";

//list find all
export const getMasterData = () => {
  return axios.get(`/master-data`);
};

// list of delivery type
export const getDeliveryType = () => {
  return axios.get(`/delivery-types/find-all`);
};

// create master data
/**
 *
 * @param {object} data
 * @param {object} data.payload - update payload
 * @param {string} data.type - key of master data to update
 * @returns
 */
export const createMasterData = async (data) => {
  const res = await axios.post(`/master-data`, data);
  return res?.data;
};

// update master data
/**
 *
 * @param {ObjectId} id
 * @param {object} data
 * @param {object} data.payload - update payload
 * @param {string} data.type - key of master data to update
 * @returns
 */
export const updateMasterData = async (id, data) => {
  const res = await axios.put(`/master-data/${id}`, data);
  return res?.data;
};

// delete master data
/**
 *
 * @param {ObjectId} id
 * @param {object} data
 * @param {string} data.type - key of master data to update
 * @returns
 */
export const deleteMasterData = async (id, data) => {
  const res = await axios.delete(`/master-data/${id}`, { data });
  return res?.data;
};

// export csv of master data
/**
 *
 * @param {object} data
 * @param {string} data.type - key of master data to update
 * @returns
 */
export const getMasterDataCsv = async (data) => {
  const res = await axios.get(`/master-data-csv`, {
    params: {
      type: data.type,
    },
  });
  return res?.data;
};

// upload edit data of master data
/**
 *
 * @param {*} data
 * @param {string} data.type - key of master data to update
 * @param {File} data.file - csv file // ?
 * @returns
 */
export const importMasterDataCsv = async (data) => {
  const res = await axios.put(`/masterdata/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
  return res?.data;
};

// product type
/**
 * @param {string} keyword - search keyword
 * @returns {Promise<Array>} - list of product types
 */
export const getAllProductType = async ({ keyword }) => {
  const data = await axios.get("/product-types", {
    params: { keyword: keyword },
  });
  return data?.data;
};

/**
 *
 * @param {ObjectId} id
 * @returns
 */
export const findProductTypeById = async (id) => {
  const data = await axios.get(`/product-type/${id}`);
  return data?.data;
};
